import { render, staticRenderFns } from "./senders-badge-state.vue?vue&type=template&id=1dce11d7&"
import script from "./senders-badge-state.vue?vue&type=script&lang=js&"
export * from "./senders-badge-state.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports